const PUBLIC_URL = process.env.PUBLIC_URL || ''

export default function publicUrl(path) {
  return `${PUBLIC_URL}${path}`
}
